<!--===============================
=            SPARKLINE            =
================================-->

<template>
  <!-- SPARKLINE CARDS -->
  <v-container>
    <v-row no-gutters>
      <base-header>
        <div slot="page-header">Sparkline</div>
      </base-header>
    </v-row>

    <v-row no-gutters>
      <!-- SPARKLINE  -->
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            Playground Sparkline
            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <div>
              <sparkline1></sparkline1>
            </div>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            Fill
            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <div>
              <fill-sparkline></fill-sparkline>
            </div>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            Take a break
            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <div>
              <take-sparkline></take-sparkline>
            </div>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            Dashboard card
            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <div>
              <dashboard-sparkline></dashboard-sparkline>
            </div>
          </div>
        </base-card>
      </v-col>
      <!-- SPARKLINE  -->
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            Custom labels
            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <div>
              <custom-sparkline></custom-sparkline>
            </div>
          </div>
        </base-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import BaseCard from "../../layout/Base/BaseCard.vue";
import BaseHeader from "../../layout/Base/BaseHeader.vue";
import CustomSparkline from "../../components/Pages/Sparklines/CustomSparkline.vue";
import DashboardSparkline from "../../components/Pages/Sparklines/DashboardSparkline.vue";
import FillSparkline from "../../components/Pages/Sparklines/FillSparkline.vue";
import Sparkline1 from "../../components/Pages/Sparklines/Sparkline1.vue";
import TakeSparkline from "../../components/Pages/Sparklines/TakeSparkline.vue";
export default {
  components: {
    BaseCard,
    BaseHeader,
    CustomSparkline,
    DashboardSparkline,
    FillSparkline,
    Sparkline1,
    TakeSparkline
  }
};
</script>

<!--====  End of SPARKLINE  ====-->
